import React, { useContext } from "react";
import { AuthContext } from "../../Authorization/AuthContext";
import AccessDeniedPage, { ACCESS_DENIED_RESOURCE } from "../AccessDeniedPage";

export const withPublicUserAuth = <P extends {}>(
  WrappedComponent: React.ComponentType<P>,
  resource: ACCESS_DENIED_RESOURCE
): React.FC<P> => {
  return (props: P) => {
    const { publicUser } = useContext(AuthContext);

    return publicUser ? (
      <WrappedComponent {...props} />
    ) : (
      <AccessDeniedPage resource={resource} />
    );
  };
};
